export default __webpack_public_path__ + "static/media/IBkneeflexionmidstance2.7cf5112e.png";